import { ORDER_STATUS } from 'my-purchases/constants/orderStatus'
import type { OrderDetailOperations } from 'my-purchases/types/purchaseDetail'

export const returnableStatuses = [
	ORDER_STATUS.shipped,
	ORDER_STATUS.in_droppoint,
	ORDER_STATUS.in_store,
	ORDER_STATUS.delivered,
	ORDER_STATUS.on_delivery,
	ORDER_STATUS.on_international_transit,
]

export const isOrderReturnable = (
	status: ORDER_STATUS,
	detailOperations?: OrderDetailOperations
) =>
	returnableStatuses.includes(status) &&
	detailOperations &&
	Object.keys(detailOperations).length > 0
